import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Live Silver Rate in India Today — Chandi Ka Bhav Per 10 Gram & Tola";
const DESC = "Today's live chandi (silver) rate in India — per 10 gram, per tola, per gram and per kg. Live gold + silver in India, refreshed every 10 min from international XAG/XAU spot + USD/INR.";

export const Route = createFileRoute("/silver-rate-india")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/silver-rate-india" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="india"
      title="Today's Live Chandi (Silver) Rate in India"
      intro="Live silver / chandi rate in India — recalculated every 10 minutes from international XAG spot price and today's USD/INR rate, sitting alongside our live 24K, 22K, 21K & 18K gold rate. Per 10 gram, per tola, per gram and per kilogram, with a 6-month silver chart and one-tap jump to today's gold rate in India."
    />
  ),
});